import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import PropTypes from 'prop-types'

import styles from './Spinner.module.css'

const antIndicatorIcon = <LoadingOutlined spin style={{ fontSize: 48, color: 'inherit' }} />

const Spinner = ({
  isLoading,
  label,
  size
}) => {
  if (!isLoading) return null

  return (
    <div className={styles.spinnerContainer}>
      <Spin indicator={antIndicatorIcon} size={size} />
      {label && (
        <div className={styles.spinnerLabel}>
          {label.split('').map((char, i) => (
            <span
              key={i}
              className={styles.letter}
              style={{ animationDelay: `${i * 0.15}s` }}
            >
              {char}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

Spinner.propTypes = {
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'large', 'default'])
}

Spinner.defaultProps = {
  isLoading: false,
  label: 'Loading',
  size: 'large'
}

export default Spinner
